import { SpaceVertical } from '@looker/components';
import type { FC } from 'react';

import type { Filter } from '../../../../../../../stores/filters';
import ClinicalRecency from '../../ClinicalRecency';
import { ClinicalDeciles } from '../../Deciles';

export const TreeIncludeExcludeHeaderSection: FC<{
  decileFilterName: string;
  recencyFilterName: string;
  onChange: (value: Filter) => void;
}> = ({ recencyFilterName, decileFilterName, onChange }) => {
  return (
    <SpaceVertical gap="u5">
      <ClinicalRecency onMultiFilterChange={onChange} filterName={recencyFilterName} label="Contextual" />

      <ClinicalDeciles filterName={decileFilterName} onMultiFilterChange={onChange} />
    </SpaceVertical>
  );
};
